const columnDataChapters = [
  {
    dataField: 'chapterNumId',
    caption: 'Id раздела',
    dataType: 'string',
    notVisible: true,
    allowSearch: false,
    allowFiltering: false
  },
  {
    dataField: 'chapterTitle',
    caption: 'Раздел',
    dataType: 'string',
    notVisible: false,
    allowSearch: true,
    allowFiltering: false
  },
  {
    dataField: 'shippingType',
    caption: 'тип склада',
    dataType: 'number',
    notVisible: true,
    allowSearch: false,
    allowFiltering: false
  },
  {
    dataField: 'orderIndex',
    caption: 'Порядковый номер',
    dataType: 'number',
    notVisible: true,
    allowSearch: false,
    allowFiltering: false
  },
  {
    dataField: 'maxIndex',
    caption: 'Максимальный номер',
    dataType: 'number',
    notVisible: true,
    allowSearch: false,
    allowFiltering: false
  }
];

export default columnDataChapters;
